<template>
    <div class="relative h-screen w-screen bg-gradient-to-br from-slate-50 to-slate-200 overflow-hidden">
        <div class="absolute inset-0 flex items-center justify-center">
            <slot></slot>
        </div>
    </div>
</template>